// extracted by mini-css-extract-plugin
export var img = "post-module--img--sl-Sq";
export var post_date = "post-module--post_date--6BJJZ";
export var post_description = "post-module--post_description--mjjat";
export var post_info_wrapper = "post-module--post_info_wrapper--g60pZ";
export var post_tag_name = "post-module--post_tag_name--oXysV";
export var post_wrapper = "post-module--post_wrapper--c5QV1";